import axios from "axios";
import {
  isAdminRoute,
  isPartnerRoute,
  removeCookieAsync,
} from "../utils";

axios.defaults.withCredentials = true;

axios.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    if (error.response.status === 401) {
      if (isAdminRoute()) {
        // Remove Admin Token
        await removeCookieAsync("a_atkn");
        await removeCookieAsync("adminId");
        window.location.href = "/admin/login";
      } else if (isPartnerRoute()) {
        // Remove Partner Token
        await removeCookieAsync("p_atkn");
        window.location.href = "/partner/login";
      } else {
        // Remove User Token
        await removeCookieAsync("atkn");
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  }
);

export default axios;
